import { createContext, useContext } from 'react';
import PropTypes from 'prop-types';

const IncidentFormContext = createContext({
  getListRoot: () => {},
  getListItems: () => {},
  uploadFile: () => {},
  getAssets: () => {},
});

export const useIncidentFormContext = () => {
  return useContext(IncidentFormContext);
};

export const IncidentFormContextProvider = ({ children, contextValue }) => {
  return <IncidentFormContext.Provider value={contextValue}>{children}</IncidentFormContext.Provider>;
};

IncidentFormContextProvider.propTypes = {
  children: PropTypes.node,
  contextValue: PropTypes.shape({
    getListRoot: PropTypes.func,
    getListItems: PropTypes.func,
  })
}